import { Link } from 'react-router-dom';

import { trackCta, trackFooter } from '@/lib/analytics';

export function Footer() {
    return (
        <footer className="w-screen bg-slate-950 py-16">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
                    {/* Logo & Description */}
                    <div className="col-span-1 md:col-span-2">
                        <div className="mb-6">
                            <img src="/images/Harmonie-Media-Logo.svg" alt="Harmonie Media" className="h-8 w-auto brightness-0 invert" />
                        </div>
                        <p className="max-w-md text-gray-400">
                            Ihr Partner für digitale Transformation. Von der Beratung bis zur Umsetzung – wir bringen Ihr Unternehmen in die digitale
                            Zukunft.
                        </p>
                        <div className="mt-6 flex space-x-4">
                            <div className="flex items-center space-x-2">
                                <div className="h-2 w-2 animate-pulse rounded-full bg-purple-400"></div>
                                <span className="text-sm text-gray-400">Made in Hessen</span>
                            </div>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="mb-4 font-semibold text-white">Kontakt</h3>
                        <div className="space-y-3">
                            <div className="flex items-center space-x-3">
                                <svg className="h-5 w-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                    />
                                </svg>
                                <Link
                                    to="/kontakt"
                                    onClick={() => trackCta('Kontaktformular', 'footer')}
                                    className="text-gray-300 transition-colors hover:text-purple-400"
                                >
                                    Kontaktformular
                                </Link>
                            </div>
                            <div className="flex items-center space-x-3">
                                <svg className="h-5 w-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                    />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <span className="text-gray-300">Hessen, Deutschland</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-12 border-t border-gray-800 pt-8">
                    <div className="flex flex-col items-center justify-between md:flex-row">
                        <p className="text-sm text-gray-500">© {new Date().getFullYear()} HM Harmonie Media GmbH. Alle Rechte vorbehalten.</p>
                        <div className="mt-4 flex space-x-6 md:mt-0">
                            <Link
                                to="/impressum"
                                onClick={() => trackFooter('impressum')}
                                className="text-sm text-gray-500 transition-colors hover:text-purple-400"
                            >
                                Impressum
                            </Link>
                            <Link
                                to="/datenschutz"
                                onClick={() => trackFooter('datenschutz')}
                                className="text-sm text-gray-500 transition-colors hover:text-purple-400"
                            >
                                Datenschutz
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
